import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-newsletter',
  templateUrl: './newsletter.component.html',
  styleUrls: ['./newsletter.component.sass']
})
export class NewsletterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
